import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-notification01',
  standalone: true,
  templateUrl: '../../assets/notification01.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamNotification01Icon {}
